module.exports = __webpack_public_path__ + "static/assets/5ce8b39a63fd372023589c5b7bcd48ca.jpg";